<!-- <p>visitor-dashboard works!</p> -->
<section *ngIf="!visitorData.flows.isVisitorGateEntry">
  <mat-card class="visitor-dashboard-card">
    <mat-card-content class="visitor-dashboard-card-content">
      <mat-grid-list cols="3" rowHeight="150px" [gutterSize]="'15px'">
        <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="visitor-counter-card"
            ><mat-card-header class="visitor-counter-card-header"
              >TODAY VISITORS</mat-card-header
            >
            <mat-card-content class="visitor-counter-card-content">
              <div
                *ngIf="!visitorData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{ statisticsData ? statisticsData.singleTotal : 0 }}
              </div>
              <div *ngIf="visitorData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">visibility</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        >
        <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="visitor-counter-card"
            ><mat-card-header class="visitor-counter-card-header"
              >TODAY VERIFIED</mat-card-header
            >
            <mat-card-content class="visitor-counter-card-content">
              <div
                *ngIf="!visitorData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{ statisticsData ? statisticsData.singleVerified : 0 }}
              </div>
              <div *ngIf="visitorData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <i class="fa-solid fa-circle-exclamation counter-icon"></i>
            </mat-card-content> </mat-card
        ></mat-grid-tile>
        <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="visitor-counter-card"
            ><mat-card-header class="visitor-counter-card-header"
              >TODAY UNVERIFIED</mat-card-header
            >
            <mat-card-content class="visitor-counter-card-content">
              <div
                *ngIf="!visitorData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{ statisticsData ? statisticsData.singleUnverified : 0 }}
              </div>
              <div *ngIf="visitorData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">verified_user</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        >
      </mat-grid-list>
      <mat-divider></mat-divider>
      <mat-grid-list cols="3" rowHeight="150px" [gutterSize]="'15px'">
        <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="visitor-counter-card"
            ><mat-card-header class="visitor-counter-card-header"
              >TOTAL VISITOR</mat-card-header
            >
            <mat-card-content class="visitor-counter-card-content">
              <div
                *ngIf="!visitorData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  visitorData.visitorDetails.totalVisitor
                    ? visitorData.visitorDetails.totalVisitor
                    : 0
                }}
              </div>
              <div *ngIf="visitorData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">visibility</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        ><mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="visitor-counter-card"
            ><mat-card-header class="visitor-counter-card-header"
              >TOTAL VERIFIED</mat-card-header
            >
            <mat-card-content class="visitor-counter-card-content">
              <div
                *ngIf="!visitorData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  visitorData.visitorDetails.totalVerified
                    ? visitorData.visitorDetails.totalVerified
                    : 0
                }}
              </div>
              <div *ngIf="visitorData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">verified_user</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        >
        <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="visitor-counter-card"
            ><mat-card-header class="visitor-counter-card-header"
              >TOTAL UNVERIFIED</mat-card-header
            >
            <mat-card-content class="visitor-counter-card-content">
              <div
                *ngIf="!visitorData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  visitorData.visitorDetails.totalUnverified
                    ? visitorData.visitorDetails.totalUnverified
                    : 0
                }}
              </div>
              <div *ngIf="visitorData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <i class="fa-solid fa-circle-exclamation counter-icon"></i>
            </mat-card-content> </mat-card
        ></mat-grid-tile>
      </mat-grid-list>
      <mat-divider></mat-divider>
      <form [formGroup]="range">
        <div class="search-filter-wrapper">
          <mat-grid-list cols="3" rowHeight="100px" [gutterSize]="'15px'">
            <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1">
              <div class="mat-inside-grid-tile">
                <mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Enter Start and End Date</mat-label>
                  <mat-date-range-input [rangePicker]="picker">
                    <input
                      matStartDate
                      formControlName="start"
                      placeholder="Start date"
                    />
                    <input
                      matEndDate
                      formControlName="end"
                      [min]="currentDate"
                      placeholder="End date"
                    />
                  </mat-date-range-input>
                  <mat-datepicker-toggle
                    matIconSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>

                  @if (range.controls.start.hasError('matStartDateInvalid')) {
                  <mat-error>Invalid start date</mat-error>
                  } @if (range.controls.end.hasError('matEndDateInvalid')) {
                  <mat-error>Invalid end date</mat-error>
                  }
                </mat-form-field>
                <button
                  *ngIf="isClickedSubmit"
                  mat-icon-button
                  (click)="onGetResetData()"
                >
                  <mat-icon>refresh</mat-icon>
                </button>
              </div>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1">
              <div class="mat-inside-grid-tile">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Visitor Search</mat-label>
                  <input
                    matInput
                    placeholder="Search by Id, Name or Phone number"
                    formControlName="visitorName"
                    [formGroup]="range"
                  />
                </mat-form-field>
              </div>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1">
              <div class="button-inside-grid-tile">
                <button
                  [disabled]="
                    !(
                      range.controls.visitorName.value ||
                      (range.controls.start.value && range.controls.end.value)
                    )
                  "
                  (click)="onGetRangeData()"
                  mat-raised-button
                >
                  Submit
                </button>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </form>
      <mat-divider></mat-divider>
      <div *ngIf="!isLoggedInUser">
        <mat-grid-list cols="3" [gutterSize]="'15px'" rowHeight="600px">
          <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 2"
            ><mat-card class="visitor-charts-card"
              ><mat-card-header class="visitor-counter-card-header"
                >VISITOR BREAKDOWN</mat-card-header
              >
              <mat-card-content class="visitor-charts-card-content">
                <app-visitor-breakdown
                  [breakdownVisitorData]="statisticsData"
                  [chartHeight]="500"
                ></app-visitor-breakdown>
              </mat-card-content> </mat-card
          ></mat-grid-tile>
          <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
            ><mat-card class="visitor-charts-card"
              ><mat-card-header class="visitor-counter-card-header"
                >TOP CATEGORIES</mat-card-header
              >
              <mat-card-content class="visitor-charts-card-content"
                ><app-visitor-categories
                  [chartData]="statisticsData"
                  [chartHeight]="500"
                ></app-visitor-categories>
              </mat-card-content> </mat-card
          ></mat-grid-tile>
        </mat-grid-list>
        <mat-divider></mat-divider>
      </div>

      <mat-grid-list cols="3" rowHeight="90px" [gutterSize]="'10px'">
        <mat-grid-tile
          *ngIf="
            (!isShowVisitorDetail && screenSize == ScreenType.Mobile) ||
            screenSize != ScreenType.Mobile
          "
          colspan="3"
          [rowspan]="
            visitorData.visitorDetails?.visitorList?.length < 5
              ? 6
              : visitorData.visitorDetails?.visitorList?.length < 8
              ? 7
              : 8
          "
        >
          <mat-card class="visitor-table-card">
            <mat-card-content class="visitor-table-card-content">
              <app-visitor-dashboard-table
                [visitorTableData]="visitorData.visitorDetails.visitorList"
                (initVisitorGateEntry)="onInitVisitorGateEntry()"
                (showVisitorDetail)="onShowVisitorDetail($event)"
                [isVisitorDetailsClosed]="isShowVisitorDetail"
              ></app-visitor-dashboard-table>
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="isShowVisitorDetail"
          colspan="3"
          [rowspan]="screenSize == ScreenType.Mobile ? 30 : 12"
        >
          <mat-card class="visitor-table-card scroll-to-visitor-details">
            <mat-card-content class="visitor-table-card-content">
              <app-visitor-detail
                [visitorDetails]="visitorDetails"
                [orgUser]="visitorData.orgUserList"
                (closeVisitorDetail)="onCloseVisitorDetail()"
                (showVisitorTimeline)="onShowVisitorTimeline($event)"
                (updateVisitorDetails)="onUpdateVisitorDetails($event)"
                (postVisitorComment)="onPostVisitorComment($event)"
              ></app-visitor-detail>
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="isShowVisitorTimline && isShowVisitorDetail"
          colspan="3"
          rowspan="4"
          ><div class="incident-timeline-card">
            <mat-card style="height: calc(100% - 10px)">
              <mat-card-content class="visitor-table-card-content">
                <app-visitor-timeline
                  [visitorTableData]="visitorDetails"
                ></app-visitor-timeline>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="isShowVisitorDetail && false"
          colspan="3"
          rowspan="4"
          ><div class="incident-timeline-card">
            <mat-card style="height: calc(100% - 10px)">
              <mat-card-content class="incident-table-card-content">
                <app-visitor-timeline-graph-container
                  [visitorData]="visitorDetails"
                  [orgUsersData]="visitorData.orgUserList"
                  [isGraph]="true"
                  (closeVisitorDetail)="onCloseVisitorDetail()"
                ></app-visitor-timeline-graph-container>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="isShowVisitorDetail && false"
          colspan="3"
          rowspan="4"
          ><div class="incident-timeline-card">
            <mat-card style="height: calc(100% - 10px)">
              <mat-card-content class="incident-table-card-content">
                <app-visitor-timeline-graph-container
                  [visitorData]="visitorDetails"
                  [orgUsersData]="visitorData.orgUserList"
                  [isGraph]="false"
                  (closeVisitorDetail)="onCloseVisitorDetail()"
                  (postVisitorComment)="onPostVisitorComment($event)"
                ></app-visitor-timeline-graph-container>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-card-content>
  </mat-card>
</section>
<div
  class="close-button-container"
  *ngIf="visitorData.flows.isVisitorGateEntry && !isCloseDisplay"
>
  <div class="close-button">
    <button (click)="onClose()" mat-raised-button>Close</button>
  </div>
  <div *ngIf="false" class="close-button">
    <button (click)="onReset()" mat-raised-button>Reset</button>
  </div>
</div>

<!-- Visitor Gate Entry -->
<section *ngIf="visitorData.flows.isVisitorGateEntry">
  <section
    *ngIf="
      !!getOnlyPendingVisitors(visitorData.visitorDetails.visitorList).length
    "
  >
    <div
      [ngClass]="{
        'visitor-pending-approvals-container':
          screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

        'visitor-pending-approvals-container-mobile':
          screenSize == ScreenType.Mobile
      }"
    >
      <div
        *ngIf="screenSize != ScreenType.Mobile"
        class="visitors-pending-table"
      >
        <table
          mat-table
          [dataSource]="
            getOnlyPendingVisitors(visitorData.visitorDetails.visitorList)
          "
        >
          <ng-container matColumnDef="no">
            <th mat-header-cell *matHeaderCellDef>No.</th>
            <td mat-cell *matCellDef="let element; let i = index">
              {{ i + 1 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="visname">
            <th
              style="border-right: 1px solid; text-align: center"
              mat-header-cell
              *matHeaderCellDef
            >
              Visitor Name
            </th>
            <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
              {{ row.firstName + " " + row.lastName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="hostname">
            <th
              style="border-right: 1px solid; text-align: center"
              mat-header-cell
              *matHeaderCellDef
            >
              Host Name
            </th>
            <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
              <p
                *ngIf="row.securityStatus != 4 && row.securityStatus != 5"
                style="margin: 0"
              >
                {{ row.hostName }}
              </p>
              <button
                *ngIf="row.securityStatus == 4 || row.securityStatus == 5"
                mat-raised-button
                [ngStyle]="
                  row.securityStatus == 4
                    ? {
                        'background-color': 'green',
                        color: 'white',
                        'font-size': '16px',
                        'font-weight': 'bold'
                      }
                    : row.securityStatus == 5
                    ? {
                        'background-color': 'red',
                        color: 'white',
                        'font-size': '16px',
                        'font-weight': 'bold'
                      }
                    : {}
                "
              >
                {{ row.hostName }}
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="date">
            <th
              style="border-right: 1px solid; text-align: center"
              mat-header-cell
              *matHeaderCellDef
            >
              Visit Date
            </th>
            <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
              {{ getFormatedDate(row.visitDateTime) | date : "E, MMMM d, y" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="Details">
            <th
              style="text-align: center"
              mat-header-cell
              *matHeaderCellDef
              aria-label="row actions"
            >
              Action
            </th>
            <td style="text-align: center" mat-cell *matCellDef="let element">
              <button
                [disabled]="
                  ((element.securityStatus == 1 ||
                    element.securityStatus == 3) &&
                    element.isPreApproved != 'true') ||
                  (element.isPreApproved == 'true' &&
                    element.checkOut != null &&
                    element.checkIn == null) ||
                  (element.isPreApproved == 'true' &&
                    element.checkIn &&
                    element.checkOut == null) ||
                  (element.isPreApproved == 'true' &&
                    element.checkIn &&
                    element.checkOut)
                "
                (click)="onShowDetails(element)"
                mat-raised-button
              >
                <mat-icon *ngIf="element.isPreApproved != 'true'"
                  >refresh</mat-icon
                >
                <mat-icon *ngIf="element.isPreApproved == 'true'"
                  >launch</mat-icon
                >
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="purpose">
            <th
              style="border-right: 1px solid"
              mat-header-cell
              *matHeaderCellDef
            >
              Purpose
            </th>
            <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
              {{ row.purpose?.length == 0 ? "Not Mentioned" : row.purpose }}
            </td>
          </ng-container>
          <ng-container matColumnDef="security">
            <th
              style="border-right: 1px solid; text-align: center"
              mat-header-cell
              *matHeaderCellDef
            >
              Host Approval
            </th>
            <td
              style="border-right: 1px solid; text-align: center"
              mat-cell
              *matCellDef="let row"
            >
              <button
                [ngStyle]="
                  row.securityStatus == 1 ||
                  row.securityStatus == 4 ||
                  row.securityStatus == 5
                    ? { 'background-color': 'green' }
                    : row.securityStatus == -1 || row.securityStatus == 3
                    ? { 'background-color': '#FFBF00' }
                    : { 'background-color': 'red' }
                "
                class="security-button"
                mat-raised-button
              >
                {{
                  row.securityStatus == -1
                    ? "Rejected"
                    : row.securityStatus == 1 && row.isGateEntry == "1"
                    ? "Approved"
                    : row.securityStatus == 3
                    ? "Auto Rejected"
                    : row.securityStatus == 0 && row.isPreApproved == "true"
                    ? "Pre-Approved"
                    : row.visitorType == "3"
                    ? "Pre-Verified"
                    : row.securityStatus == 4
                    ? "In Progress"
                    : row.securityStatus == 5
                    ? "Completed"
                    : "Pending"
                }}
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="time">
            <th
              style="border-right: 1px solid; text-align: center"
              mat-header-cell
              *matHeaderCellDef
            >
              Visit Time
            </th>
            <td
              style="border-right: 1px solid; text-align: center"
              mat-cell
              *matCellDef="let row"
            >
              <!-- {{ row.visitDateTime | date : "hh:mm a" }} -->
              <ng-container *ngIf="row.isPreApproved == 'true'; else dateTime">
                <!-- <button
                  [ngStyle]="
                    (getVisitorTimerMinutes(row) | async) >= 15 &&
                    row.checkOut == null
                      ? { 'background-color': 'green', color: 'white' }
                      : (getVisitorTimerMinutes(row) | async) < 15 &&
                        (getVisitorTimerMinutes(row) | async) > 0 &&
                        row.checkOut == null
                      ? { 'background-color': 'orange', color: 'white' }
                      : (getVisitorTimerMinutes(row) | async) == 0 &&
                        hasVisitorTimer(row.visitorID) &&
                        row.checkOut == null
                      ? { 'background-color': 'red', color: 'white' }
                      : !hasVisitorTimer(row.visitorID) && row.checkOut == null
                      ? { 'background-color': 'lightskyblue' }
                      : { 'background-color': 'darkgray' }
                  "
                  class="security-button"
                  mat-raised-button
                >
                  {{
                    hasVisitorTimer(row.visitorID) &&
                    (getVisitorTimerMinutes(row) | async) != 0 &&
                    row.checkOut == null
                      ? (getVisitorTimerObservable(row) | async)
                      : (getVisitorTimerMinutes(row) | async) == 0 &&
                        hasVisitorTimer(row.visitorID) &&
                        row.checkOut == null
                      ? "Time Expired"
                      : row.checkOut != null
                      ? "Visited"
                      : "Not yet Arrived"
                  }}
                </button> -->
                <button
                  class="security-button"
                  [ngStyle]="
                    row.checkIn == null
                      ? { 'background-color': 'lightskyblue', color: 'black' }
                      : row.checkIn &&
                        row.checkOut == null &&
                        (getExpectedCheckoutTimeNumber(row) | async) > 15
                      ? { 'background-color': 'green', color: 'white' }
                      : row.checkIn &&
                        row.checkOut == null &&
                        (getExpectedCheckoutTimeNumber(row) | async) <= 15 &&
                        (getExpectedCheckoutTimeNumber(row) | async) >= 2
                      ? { 'background-color': 'orange', color: 'white' }
                      : row.checkIn &&
                        row.checkOut == null &&
                        (getExpectedCheckoutTimeNumber(row) | async) < 2
                      ? { 'background-color': 'red', color: 'white' }
                      : { 'background-color': 'darkgray' }
                  "
                  mat-raised-button
                >
                  {{
                    row.checkIn == null
                      ? "Not yet arrived"
                      : row.checkIn &&
                        row.checkOut == null &&
                        (getExpectedCheckoutTimeNumber(row) | async) > 0
                      ? (getExpectedCheckoutTime(row) | async)
                      : row.checkIn &&
                        row.checkOut == null &&
                        (getExpectedCheckoutTimeNumber(row) | async) == 0
                      ? "Time Expired"
                      : row.checkOut != null
                      ? "Visited"
                      : ""
                  }}
                </button>
              </ng-container>
              <ng-template #dateTime>
                {{ getFormatedDate(row.visitDateTime) | date : "hh:mm a" }}
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="details">
            <th
              style="border-right: 1px solid; text-align: center"
              mat-header-cell
              *matHeaderCellDef
              aria-label="row actions"
            ></th>
            <td
              style="border-right: 1px solid; text-align: center"
              mat-cell
              *matCellDef="let element"
            ></td>
          </ng-container>
          <tr
            class="table-header"
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <div *ngIf="screenSize === ScreenType.Mobile">
        <app-mobile-table-card
          [visitorTableData]="
            getOnlyPendingVisitors(visitorData.visitorDetails.visitorList)
          "
          [tableType]="'gateVisitor'"
          (showDetails)="onShowDetails($event)"
        >
        </app-mobile-table-card>
      </div>
    </div>
  </section>
  <mat-divider></mat-divider>
  <mat-divider></mat-divider>
  <!-- <section class="visitor-host-approval-section" *ngIf="showWaitingSection">
    <app-pending-host-approvals
      [visitorDetails]="expandedVisitorDetails"
      (checkVisitorStatus)="checkStatus($event)"
    ></app-pending-host-approvals>
  </section> -->
  <!-- <section
    *ngIf="
      showWaitingSection && !visitorData.status.isFetchingAPIRequest && false
    "
    class="visitor-host-approval-section"
    #whenhostgetsnotified
  >
    <div
      [ngStyle]="true ? { background: 'green' } : {}"
      class="visitor-gate-entry-header"
    >
      Your host {{ hostName | uppercase }} has been notified, please wait!
    </div>
    <mat-divider></mat-divider>
    <div class="visitor-host-approval-form">
      <form [formGroup]="visitorGuardConfirm">
        <mat-grid-list cols="3" rowHeight="80px" gutterSize="25px">
          <mat-grid-tile
            *ngIf="
              visitorData.gateEntryVisitor.visitorDetails.isHostVerified == '0'
            "
            rowspan="4"
          >
            <img src="assets/lottie/waiting.gif" alt="" />
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="
              visitorData.gateEntryVisitor.visitorDetails.isHostVerified == '1'
            "
            rowspan="4"
            ><div #QrCode>
              <qrcode
                [qrdata]="visitorData.gateEntryVisitor.visitorDetails.visitorID"
                [allowEmptyString]="true"
                [ariaLabel]="'QR Code image with the following content...'"
                [cssClass]="'center'"
                [elementType]="'canvas'"
                [errorCorrectionLevel]="'M'"
                [title]="'Visitor Invite Data'"
                [width]="300"
              ></qrcode>
            </div>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="!isTimerFinished">
            <div class="host-approval-timer">
              {{ display }}
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="
              visitorData.gateEntryVisitor.visitorDetails.isHostVerified == '0'
            "
          >
            <div class="notify-host-button">
              <button
                [disabled]="!isTimerFinished"
                (click)="checkStatus($event)"
                mat-raised-button
              >
                Check Status
              </button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="isTimerFinished"
            [colspan]="
              visitorData.gateEntryVisitor.visitorDetails.isHostVerified == '-1'
                ? 3
                : 1
            "
          >
            <div
              class="notify-host-button"
              *ngIf="visitorData.gateEntryVisitor.isFetchingHostStatus"
            >
              <mat-spinner [diameter]="52"></mat-spinner>
            </div>
            <div
              [ngStyle]="
                visitorData.gateEntryVisitor.visitorDetails.isHostVerified ==
                '1'
                  ? { background: 'green' }
                  : visitorData.gateEntryVisitor.visitorDetails
                      .isHostVerified == '-1'
                  ? { background: 'red' }
                  : { background: 'gray' }
              "
              class="notify-status"
              *ngIf="!visitorData.gateEntryVisitor.isFetchingHostStatus"
            >
              {{
                visitorData.gateEntryVisitor.visitorDetails.isHostVerified ==
                "1"
                  ? "PERMITTED"
                  : visitorData.gateEntryVisitor.visitorDetails
                      .isHostVerified == "-1"
                  ? "RESTRICTED"
                  : "WAITING"
              }}
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="
              visitorData.gateEntryVisitor.visitorDetails.isHostVerified == '1'
            "
            ><mat-form-field
              
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Security Guard</mat-label>
              <input
                readonly
                matInput
                formControlName="guardName"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            *ngIf="
              visitorData.gateEntryVisitor.visitorDetails.isHostVerified == '1'
            "
            ><mat-form-field
              
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Check In</mat-label>
              <input matInput formControlName="checkIn" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            *ngIf="
              visitorData.gateEntryVisitor.visitorDetails.isHostVerified == '1'
            "
          >
            <div class="notify-host-button">
              <button
                (click)="captureScreen()"
                [disabled]="
                  !(
                    visitorData.gateEntryVisitor.visitorDetails
                      .isHostVerified == '1'
                  )
                "
                mat-raised-button
              >
                Clear Entry
              </button>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </form>
    </div>
  </section> -->
  <div
    *ngIf="visitorData.status.isFetchingAPIRequest"
    style="width: calc(100% - 15px)"
    class="loading-spinner"
  >
    <mat-spinner></mat-spinner>
  </div>
  <section
    *ngIf="
      !visitorData.flows.isShowWaitingSection &&
      !visitorData.status.isFetchingAPIRequest
    "
    #whenhostisnotnotified
  >
    <div
      [ngClass]="{
        'visitor-gate-entry-header':
          screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

        'visitor-gate-entry-header-mobile': screenSize == ScreenType.Mobile
      }"
    >
      New Visitor &#64;{{ timeNow | date : "medium" }}
    </div>
    <mat-divider></mat-divider>
    <!-- <div class="visitor-exist-status">
      <div
        *ngIf="!isUniqueVisitor && isValid"
        class="warn-banner"
        [ngStyle]="
          screenSize != ScreenType.Mobile
            ? { 'font-size': '16px' }
            : screenSize == ScreenType.Mobile
            ? { 'font-size': '14px' }
            : {}
        "
      >
        Visitor with mobile number
        {{ visitorGateEntryPass.get("phoneNumber").value }} had already in our
        records, Please re-scehdule!
      </div>
      <div
        *ngIf="!isUniqueVisitor && !isValid"
        class="error-banner"
        [ngStyle]="
          screenSize != ScreenType.Mobile
            ? { 'font-size': '16px' }
            : screenSize == ScreenType.Mobile
            ? { 'font-size': '14px' }
            : {}
        "
      >
        <div class="prompt-message">
          Visitor with mobile number
          {{ visitorGateEntryPass.get("phoneNumber").value }} had already
          scehduled and not yet checkedout!
        </div>
        <button (click)="onManualCheckVisitor()" mat-raised-button>
          Check-Out
        </button>
      </div>
    </div> -->
    <div class="visitor-gate-entry-form">
      <form [formGroup]="visitorGateEntryPass">
        <mat-grid-list
          [cols]="screenSize == ScreenType.Mobile ? 1 : 3"
          rowHeight="80px"
          gutterSize="25px"
        >
          <mat-grid-tile
            [rowspan]="showWebcam && screenSize == ScreenType.Mobile ? 6 : 5"
          >
            <div class="open-camera-visitor-entry">
              <div *ngIf="showWebcam">
                <webcam
                  [trigger]="invokeObservable"
                  [switchCamera]="nextWebcamObservable"
                  (imageCapture)="captureImg($event)"
                  [width]="screenSize == ScreenType.Mobile ? 320 : 450"
                  [height]="screenSize == ScreenType.Mobile ? 410 : 350"
                ></webcam>
              </div>
              <div *ngIf="!showWebcam" class="captured-image-container">
                <img [src]="sysImage" />
              </div>

              <div class="open-camera-button">
                <div>
                  <mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Select Camera</mat-label>
                    <mat-select
                      [disabled]="isDisabled"
                      [value]="deviceSelected"
                      (valueChange)="onDeviceSelectChange($event)"
                    >
                      <mat-option
                        *ngFor="let device of availableDevices"
                        [value]="device.deviceId"
                        >{{ device.label }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
                <button
                  [disabled]="!isDeviceSelected"
                  (click)="getSnapshot()"
                  type="button"
                  mat-raised-button
                >
                  {{
                    showWebcam || !isDeviceSelected ? "Capture" : "ReCapture"
                  }}
                </button>
              </div>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="
              (!isUniqueVisitor && isValid) ||
              (!isUniqueVisitor && !isValid && !isManuallyCheck) ||
              (!isUniqueVisitor && !isValid && isManuallyCheck)
            "
            [colspan]="screenSize == ScreenType.Mobile ? '1' : '2'"
          >
            <div class="form-field-updates">
              <div
                *ngIf="!isUniqueVisitor && isValid"
                class="warn-banner"
                [ngStyle]="
                  screenSize != ScreenType.Mobile
                    ? { 'font-size': '14px' }
                    : screenSize == ScreenType.Mobile
                    ? { 'font-size': '12px' }
                    : {}
                "
              >
                <div class="warn-banner-text">
                  {{ phoneForm.get("phone").value }} already exists, Please
                  re-schedule!
                </div>
                <button (click)="onEditDetails()" mat-raised-button>
                  Edit Record
                </button>
                <div
                  *ngIf="!isUniqueVisitor && isValid"
                  class="searched-image-container"
                >
                  <img [src]="searchedImage" alt="Searched Image" />
                </div>
              </div>

              <div
                *ngIf="!isUniqueVisitor && !isValid && !isManuallyCheck"
                class="error-banner"
                [ngStyle]="
                  screenSize != ScreenType.Mobile
                    ? { 'font-size': '16px' }
                    : screenSize == ScreenType.Mobile
                    ? { 'font-size': '14px' }
                    : {}
                "
              >
                <div class="prompt-message">
                  {{ phoneForm.get("phone").value }} not yet checked-out!
                </div>
                <button (click)="onManualCheckVisitor()" mat-raised-button>
                  Check-Out
                </button>
              </div>
              <div
                *ngIf="!isUniqueVisitor && !isValid && isManuallyCheck"
                class="warn-banner"
                [ngStyle]="
                  screenSize != ScreenType.Mobile
                    ? { 'font-size': '16px' }
                    : screenSize == ScreenType.Mobile
                    ? { 'font-size': '14px' }
                    : {}
                "
              >
                <div class="prompt-message">
                  {{ phoneForm.get("phone").value }} been manually checked-out!
                </div>
                <button (click)="onEditDetails()" mat-raised-button>
                  Edit Record
                </button>
              </div>
            </div>
          </mat-grid-tile>
          <form class="phone-form-field" #f="ngForm" [formGroup]="phoneForm">
            <mat-grid-tile>
              <mat-form-field
                class="custom-padding-fix"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <ngx-mat-intl-tel-input
                  #phoneInput
                  [enablePlaceholder]="true"
                  [required]="true"
                  [preferredCountries]="['in']"
                  [enableSearch]="true"
                  name="phone"
                  formControlName="phone"
                  [inputPlaceholder]="'Phone Number*'"
                  [label]="'Phone Number'"
                  [maxlength]="15"
                  (change)="onChangeNumber($event)"
                  (keypress)="inputValidator($event)"
                ></ngx-mat-intl-tel-input>
              </mat-form-field>
            </mat-grid-tile>
          </form>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Address</mat-label>

              <textarea
                formControlName="visitorAddress"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="1"
                matInput
              ></textarea>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Gender</mat-label>
              <mat-select formControlName="gender">
                <mat-option value="male">Male</mat-option>
                <mat-option value="female">Female</mat-option>
                <mat-option value="other">Other</mat-option>
              </mat-select>
            </mat-form-field></mat-grid-tile
          >
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Purpose</mat-label>
              <mat-select formControlName="purpose">
                <mat-option value="Personal"> Personal </mat-option>
                <mat-option value="Official"> Official </mat-option>
                <mat-option value="Delivery"> Delivery </mat-option>
                <mat-option value="Meeting"> Meeting </mat-option>
                <mat-option value="Private"> Private </mat-option>
                <mat-option value="Classified"> Classified </mat-option>
              </mat-select>
            </mat-form-field></mat-grid-tile
          >
          <mat-grid-tile *ngIf="false">
            <mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Department</mat-label>
              <mat-select formControlName="department">
                <mat-option> Select </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field
              *ngIf="isDisabled"
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Select Hosts*</mat-label>
              <input [disabled]="isDisabled" matInput />
            </mat-form-field>
            <mat-form-field
              *ngIf="!isDisabled"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <mat-label>Select Hosts*</mat-label>
              <input
                matInput
                [formControl]="selectedUsersControl"
                [matAutocomplete]="autoAdmin"
              />
              <mat-icon
                style="background-color: transparent; color: #e93578"
                matSuffix
                (click)="clearInputField()"
                >clear</mat-icon
              >
              <mat-autocomplete
                (optionSelected)="addUser($event)"
                #autoAdmin="matAutocomplete"
              >
                <mat-option
                  *ngFor="let host of filteredHosts"
                  [value]="host.firstname + ' ' + host.lastname"
                >
                  <img
                    class="visitor-img"
                    [src]="host.profilePicture"
                    height="30"
                    width="36"
                  />
                  <span> {{ host.firstname + " " + host.lastname }}</span>

                  <!-- <small>{{ visitor.phoneNumber }}</small> -->
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="usersTemp.length > 0"
            [colspan]="screenSize == ScreenType.Mobile ? '1' : '2'"
          >
            <div class="selected-users">
              <mat-chip
                *ngFor="let user of usersTemp"
                [removable]="true"
                (removed)="removeUser(user)"
              >
                {{ user }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Visitor Category</mat-label>
              <mat-select formControlName="visitorCategory">
                <mat-option value="New Visitor"> New Visitor </mat-option>
                <mat-option value="Delivery"> Delivery </mat-option>
                <mat-option value="Domestic"> Domestic </mat-option>
                <mat-option value="Contractor"> Contractor </mat-option>
                <mat-option value="Guest"> Guest </mat-option>
                <mat-option value="Driver"> Driver </mat-option>
                <mat-option value="Labour"> Labour</mat-option>
                <mat-option value="Service"> Service </mat-option>
                <mat-option value="Swiggy"> Food Delivery - Swiggy </mat-option>
                <mat-option value="Zomato"> Food Delivery - Zomato </mat-option>
                <mat-option value="Amazon"> Amazon Delivery </mat-option>
                <mat-option value="FlipKart"> FlipKart Delivery </mat-option>
                <mat-option value="Myntra"> Myntra Delivery </mat-option>
                <mat-option value="Uber"> Uber </mat-option>
                <mat-option value="Ola"> Ola </mat-option>
                <mat-option value="Taxi"> Taxi </mat-option>
                <mat-option value="Grocery"> Grocery </mat-option>
                <mat-option value="Laundry"> Laundry </mat-option>
                <mat-option value="Carpenter "> Carpenter </mat-option>
                <mat-option value="Electrician"> Electrician </mat-option>
                <mat-option value="Plumber"> Plumber </mat-option>
                <mat-option value="Cableman"> Cableman </mat-option>
                <mat-option value="Postman"> Postman </mat-option>
                <mat-option value="Newspaperman"> Newspaperman </mat-option>
                <mat-option value="Milkman "> Milkman </mat-option>
                <mat-option value="Help "> Help </mat-option>
                <mat-option value="Other"> Other </mat-option>
              </mat-select>
            </mat-form-field></mat-grid-tile
          >

          <mat-grid-tile>
            <mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Vehicle Number</mat-label>
              <mat-select
                *ngIf="!isManualVehicle"
                (selectionChange)="onChangeSelected($event)"
                formControlName="carRegistration"
              >
                <mat-option value="manual">
                  {{ "Type Manually" }}
                </mat-option>
                <mat-option
                  *ngFor="let list of visitorData.orgVehicleNumberPlates"
                  [value]="list.platesText"
                >
                  {{ list.platesText }}
                </mat-option>
              </mat-select>
              <input
                *ngIf="isManualVehicle"
                matInput
                formControlName="carRegistration"
              />
              <button
                *ngIf="isManualVehicle"
                matSuffix
                mat-icon-button
                (click)="isManualVehicle = false"
              >
                <!-- <mat-icon>close</mat-icon> -->
                <mat-icon>arrow_drop_down_circle</mat-icon>
              </button>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            ><div class="checkbox-container">
              <mat-checkbox
                formControlName="sendQR"
                [checked]="isChecked"
                (change)="onCheckboxChange()"
                >Send Visitor QR</mat-checkbox
              >
            </div></mat-grid-tile
          >
          <mat-grid-tile
            [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
            [rowspan]="
              screenSize == ScreenType.Mobile
                ? 3
                : screenSize == ScreenType.Tablet
                ? 2
                : 1
            "
          >
            <div class="checkbox-container">
              <mat-checkbox
                formControlName="privacyPolicyAccepted"
                required
                color="primary"
              >
                <!-- I have read and accept the -->
                By providing your information, you consent to the collection,
                processing, and use of your data as outlined in our privacy
                policy ({{ orgName }}). Your data may be shared with third
                parties for the purpose of marketing, security, visitor
                verification, and facility access management. You may withdraw
                your consent at any time. For more details, please refer to our
                full
                <a
                  (click)="openPrivacyPolicy(); $event.preventDefault()"
                  href="javascript:void(0)"
                  >Privacy Policy</a
                >
              </mat-checkbox>
            </div>
          </mat-grid-tile>

          <mat-grid-tile>
            <div class="notify-host-button">
              <button
                [disabled]="
                  visitorGateEntryPass.invalid ||
                  !this.visitorGateEntryPass.get('privacyPolicyAccepted') ||
                  isDisabled
                "
                (click)="notifyHost()"
                mat-raised-button
              >
                Notify Host
              </button>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </form>
    </div>
  </section>
</section>
<!-- CLear Entry Dialog Content -->
<ng-template #ClearEntryDialog>
  <h2 matDialogTitle>Visitor Re-Check In!</h2>
  <mat-dialog-content style="display: flex">
    Updating details, Please wait !<mat-spinner [diameter]="20"></mat-spinner>
  </mat-dialog-content>
</ng-template>

<ng-template #RefreshingVisitor>
  <h2 matDialogTitle>Refreshing Visitor Data</h2>
  <mat-dialog-content><i>Please wait!</i> </mat-dialog-content>
  <mat-dialog-actions>
    <mat-spinner></mat-spinner>
  </mat-dialog-actions>
</ng-template>

<ng-template #PrivacyPolicyVisitor>
  <div class="privacy-policy-container">
    <h2 class="policy-title">Data Privacy Policy for Visitors</h2>
    <mat-dialog-content>
      <div class="privacy-policy-content">
        <div class="policy-header">
          <p><strong>Effective Date: 26th March 2025</strong></p>
        </div>
        <p class="policy-intro">
          At {{ orgName }}, we are committed to protecting your privacy and
          ensuring that your personal data is handled in a safe and responsible
          manner. This Data Privacy Policy describes how we collect, use,
          disclose, and safeguard your information when you visit our website or
          engage with us in other ways.
        </p>

        <div class="policy-section">
          <h3 class="section-title">1. Information We Collect</h3>
          <p>
            We collect the following types of data from visitors to our website
            or physical location:
          </p>
          <ul class="policy-list">
            <li>
              <span class="list-title">Personal Information:</span> This may
              include your name, email address, phone number, mailing address,
              or other personal identifiers when you provide them voluntarily.
            </li>
            <li>
              <span class="list-title">Usage Data:</span> We collect information
              about how you interact with our website, including your IP
              address, browser type, device information, pages visited, and time
              spent on the site.
            </li>
            <li>
              <span class="list-title">Cookies and Tracking Technologies:</span>
              We use cookies, web beacons, and similar technologies to track
              your browsing activity on our website to improve user experience,
              analyze trends, and provide personalized content or ads.
            </li>
            <li>
              <span class="list-title">Location Data:</span> With your consent,
              we may collect information about your geographic location.
            </li>
          </ul>
        </div>
        <div class="policy-section">
          <h3 class="section-title">2. How We Use Your Data</h3>
          <p>We use your data for the following purposes:</p>
          <ul class="policy-list">
            <li>
              <span class="list-title">To Provide Services:</span> To provide
              you with the services you have requested, including responding to
              inquiries, processing orders, or fulfilling other obligations.
            </li>
            <li>
              <span class="list-title">To Improve Our Website:</span> To enhance
              user experience, track user behaviour, and improve content,
              design, and functionality.
            </li>
            <li>
              <span class="list-title">For Marketing:</span> With your consent,
              we may send you promotional emails, newsletters, or updates about
              our products and services.
            </li>
            <li>
              <span class="list-title">For Legal Compliance:</span> To comply
              with applicable laws, regulations, and legal processes, and to
              protect our rights or the rights of others.
            </li>
          </ul>
        </div>

        <div class="policy-section">
          <h3 class="section-title">3. Third-Party Sharing</h3>
          <p>
            We do not sell, rent, or trade your personal data. However, we may
            share your information with trusted third parties under the
            following circumstances:
          </p>
          <ul class="policy-list">
            <li>
              <span class="list-title">Service Providers:</span> We may share
              data with third-party vendors who perform services on our behalf,
              such as payment processors, marketing platforms, and hosting
              services.
            </li>
            <li>
              <span class="list-title">Legal Requirements:</span> We may
              disclose your data if required by law or in response to valid
              legal processes (e.g., subpoenas, court orders).
            </li>
            <li>
              <span class="list-title">Business Transfers:</span> If we are
              involved in a merger, acquisition, or sale of assets, your
              personal data may be transferred to the new owner.
            </li>
          </ul>
        </div>

        <div class="policy-section">
          <h3 class="section-title">4. Data Retention</h3>
          <p>
            We retain your personal data only for as long as necessary to fulfil
            the purposes outlined in this policy or to comply with legal or
            regulatory requirements. When we no longer need your personal data,
            we will securely delete or anonymize it.
          </p>
        </div>

        <div class="policy-section">
          <h3 class="section-title">5. Your Rights</h3>
          <p>
            Depending on your jurisdiction, you may have the following rights
            regarding your personal data:
          </p>
          <ul class="policy-list">
            <li>
              <span class="list-title">Access:</span> You can request a copy of
              the personal data we hold about you.
            </li>
            <li>
              <span class="list-title">Correction:</span> You can request to
              update or correct any inaccurate or incomplete personal data.
            </li>
            <li>
              <span class="list-title">Deletion:</span> You can request the
              deletion of your personal data, subject to certain exceptions.
            </li>
            <li>
              <span class="list-title">Opt-Out of Marketing:</span> You can
              unsubscribe from promotional emails at any time by clicking the
              unsubscribe link in the email.
            </li>
            <li>
              <span class="list-title">Data Portability:</span> You can request
              to receive your personal data in a structured, commonly used
              format.
            </li>
            <li>
              <span class="list-title">Withdraw Consent:</span> If you have
              provided consent for processing your personal data, you can
              withdraw your consent at any time.
            </li>
          </ul>
          <p>
            To exercise these rights, please contact us using the details
            provided below.
          </p>
        </div>

        <div class="policy-section">
          <h3 class="section-title">6. Data Security</h3>
          <p>
            We implement reasonable technical and organizational measures to
            protect your personal data from unauthorized access, use, or
            disclosure. While we strive to protect your information, please be
            aware that no method of data transmission over the internet or
            electronic storage is 100% secure.
          </p>
        </div>

        <div class="policy-section">
          <h3 class="section-title">7. International Transfers</h3>
          <p>
            If you are located outside of India, please note that your data may
            be transferred to and processed in India or other countries where we
            or our service providers operate. We will take appropriate steps to
            ensure your personal data is treated securely and in accordance with
            this policy.
          </p>
        </div>

        <div class="policy-section">
          <h3 class="section-title">8. Children's Privacy</h3>
          <p>
            Our services are not intended for children under the age of 13 (or
            16, depending on jurisdiction), and we do not knowingly collect or
            solicit personal information from children. If we learn that we have
            collected personal information from a child without verification of
            parental consent, we will take steps to delete that information.
          </p>
        </div>

        <div class="policy-section">
          <h3 class="section-title">9. Changes to This Policy</h3>
          <p>
            We may update this Data Privacy Policy from time to time to reflect
            changes in our practices, technology, legal requirements, or other
            factors. We will notify you of any significant changes by posting an
            updated version on our website or by other means. The "Effective
            Date" at the top of this policy indicates the date of the latest
            revision.
          </p>
        </div>

        <div class="policy-section contact-section">
          <h3 class="section-title">10. Contact Us</h3>
          <p>
            If you have any questions or concerns about this Data Privacy Policy
            or how we handle your personal data, please contact us at:
          </p>
          <div class="contact-info">
            {{ orgName }}<br />
            {{ orgAddress != null ? orgAddress : "" }}<br />
            <a *ngif="orgEmail" [href]="'mailto:' + orgEmail">{{ orgEmail }}</a>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" mat-dialog-close>Close</button>
    </mat-dialog-actions>
  </div>
</ng-template>
